import { gql } from "@apollo/client";

export const CREATE_AUTO_TEMPLATE = gql`
  mutation CreateAutoTemplate(
    $createTemplateInput: CreateAutoTemplateInput!
  ) {
    createAutoTemplate(createTemplateInput: $createTemplateInput) {
      ok
      templateUuid
    }
  }
`;

export const UPLOAD_PDF_AND_EXTRACT_TEXT = gql`
  mutation UploadPdfAndExtractText(
    $storageObjectName: String!
    $templateType: String!
    $templateUuid: String
  ) {
    uploadPdfAndExtractText(
      storageObjectName: $storageObjectName
      templateType: $templateType
      templateUuid: $templateUuid
    ) {
      SUBJECTIVE
      OBJECTIVE
      ASSESSMENT
      PLAN
      CUSTOM
    }
  }
`;

export const UPDATE_AUTO_TEMPLATE = gql`
  mutation UpdateAutoTemplate($input: UpdateAutoTemplateInput!) {
    updateAutoTemplate(updateTemplateInput: $input) {
      ok
    }
  }
`;
export const DELETE_AUTO_TEMPLATE = gql`
  mutation DeleteAutoTemplate($templateUuid: String!) {
    deleteAutoTemplate(templateUuid: $templateUuid) {
      ok
    }
  }
`;

export const CREATE_TEMPLATE_PREVIEW = gql`
  mutation CreateTemplatePreview(
    $createTemplatePreviewInput: TemplatePreviewInput!
  ) {
    createTemplatePreview(
      createTemplatePreviewInput: $createTemplatePreviewInput
    ) {
      ok
    }
  }
`;
